import { Component } from '@angular/core';
import { RoleHelper } from 'src/core/helpers/role-helper';

@Component({
  selector: 'ca-privacy-setting-group',
  templateUrl: './privacy-setting-group.component.html',
  styleUrl: './privacy-setting-group.component.scss',
  standalone: false,
})
export class PrivacySettingGroupComponent {
  activeTab: number = 1;

  isSuperAdminUser: boolean = false;

  constructor(private roleHelper: RoleHelper) {
    this.isSuperAdminUser = this.roleHelper.isSuperAdminUser();
  }
}
